import eventNames from 'src/analytics/eventNames';
import track from 'src/analytics/track';

export function trackAccountStandalonePopupClose() {
  track(eventNames.account_standalone_popup_close);
}
